import {
  Flex,
  Input,
  Grid,
  Button,
  GridItem,
  Heading,
  Select,
  Box,
  FormLabel,
} from "@chakra-ui/react";
import { TopDisplay } from "../../../components";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import apiCall from "../../../utils/apiCall";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useAtom } from "jotai";
import {
  notificationAtom,
  openNAtom,
  openAtom,
  modalAtom,
} from "../../../context";
import { format } from "date-fns";
import { Text } from "@chakra-ui/react";

// Validation Schemas
const AddSchema = Yup.object({
  reference: Yup.string().required("Reference is required"),
});

const SecondSchema = Yup.object({
  reference: Yup.string().required("Reference is required"),
  paymentChannel: Yup.string().required("Payment Channel is required"),
});

export default function ConfirmRequeryPayments() {
  const [, set_notification] = useAtom(notificationAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const queryClient = useQueryClient();

 const { data: PaymentChannel } = useQuery({
  queryKey: ['payment-channel'],
  queryFn: async () => {
    return apiCall().get(`/Payment/GetPaymenChannel?`);
  },
  select: (res: any) => res.data.Data,
});



  const { mutate: addUpdate, isLoading } = useMutation({
    mutationFn: async (reference: string) =>
      await apiCall().get(`/Exam/examAdvice?Reference=${reference}`),
    onSuccess: (data) => {
      const info = data?.data?.Data || {};
      set_modal({
        header: "Payment Information",
        content: (
          <Grid>
            <GridItem as={Flex} justify="space-between" p="10px 0">
              <span>Payment Status</span>
              <span>{info.Status || "Not Available"}</span>
            </GridItem>
            <GridItem as={Flex} justify="space-between" p="10px 0">
              <span>Transaction Date</span>
              <span>
                {info.PaymentDate
                  ? format(new Date(info.PaymentDate), "dd/MM/yyyy")
                  : "Not Available"}
              </span>
            </GridItem>
            <GridItem as={Flex} justify="space-between" p="10px 0">
              <span>Transaction Amount</span>
              <span>{info.Amount || "Not Available"}</span>
            </GridItem>
            <GridItem as={Flex} justify="space-between" p="10px 0">
              <span>Purpose</span>
              <span>{info.Purpose || "Not Available"}</span>
            </GridItem>
          </Grid>
        ),
      });
      set_open(true);
      queryClient.invalidateQueries({ queryKey: ["requery-payment"] });

      set_notification({
        type: "success",
        message: data?.data?.Message || "Query Successful",
      });
      set_Nopen(true);
    },
    onError: (error: any) => {
      set_notification({
        type: "error",
        message:
          error?.response?.data?.Message || "An unexpected error occurred",
      });
      set_Nopen(true);
    },
  });

  const { mutate: secondQuery, isLoading: isSecondLoading } = useMutation({
 mutationFn: async (values: { reference: string; paymentChannel: string }) => {
  console.log("outgoing values:", values);
  return await apiCall().get(
    `/payment/${values.reference}/QueryProcessedPayment?paymentChannel=${values.paymentChannel}`
  );
},

    onSuccess: (data: any) => {
      set_notification({
        type: "success",
        message: data?.data?.Message || "Payment Requery Successful",
      });
      set_Nopen(true);
      queryClient.invalidateQueries({ queryKey: ["second-requery"] });
    },
    onError: (error: any) => {
      set_notification({
        type: "error",
        message: error?.response?.data?.Message || "Error Occurred",
      });
      set_Nopen(true);
    },
  });

  return (
    <Grid>
      <TopDisplay label="Payment Status Requery" />

      {/* First Form */}
      <Formik
        initialValues={{ reference: "" }}
        validationSchema={AddSchema}
        onSubmit={(values) => addUpdate(values.reference)}
      >
        {({ errors, touched }) => (
          <Form>
            <Flex
              flexDir="column"
              maxW="500px"
              align="center"
              gap="20px"
              pt="30px"
            >
              <Field
                as={Input}
                name="reference"
                placeholder="Payment Reference No"
                borderWidth="2px"
                borderColor="green"
                borderStyle="solid"
                bg="white"
              />
              <ErrorMessage name="reference">
                {(msg) => <Text color="red.500">{msg}</Text>}
              </ErrorMessage>              <Button
                type="submit"
                isLoading={isLoading}
                bg="var(--dark-green-color)"
                color="var(--white-color)"
              >
                Check Payment Status
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>

      {/* Second Form */}
      <Heading fontSize="1.6rem" textAlign="left" mt="30px">
        Transaction Requery
      </Heading>

      <Formik
        initialValues={{ reference: "", paymentChannel: "" }}
        validationSchema={SecondSchema}
        onSubmit={(values) => secondQuery(values)}
      >
        {({ errors, touched }) => (
          <Form>
            <Flex
              flexDir={"column"}
              maxW="500px"
              align={"center"}
              gap="40px"
              pt="10px"
            >
              <Box w="100%" mb="4">
                Select Payment Channel Before Requery <br />
               <Field
                as={Select}
                name="paymentChannel"
                placeholder="Select Payment Channel"
                borderWidth="2px"
                borderColor="green"
                borderStyle="solid"
                bg="white"
                color="green"
              >
                {Array.isArray(PaymentChannel) &&
                  PaymentChannel.map((item: any) => (
                    <option key={item.Name} value={item.Name}>
                      {item.Name}
                    </option>
                  ))}
              </Field>

              </Box>

              <Box w="100%" mb="4">
                Insert Reference <br />
                <Field
                  as={Input}
                  name="reference"
                  placeholder="Transaction Reference No"
                  borderWidth="2px"
                  borderColor="green"
                  borderStyle="solid"
                  bg="white"
                />
              </Box>

              <Button
                type="submit"
                bg="var(--dark-green-color)"
                color="var(--white-color)"
                isLoading={isSecondLoading}
              >
                Requery Payment
              </Button>
            </Flex>
          </Form>

        )}
      </Formik>
    </Grid>
  );
}
